<template>
    <tab-layout :buttons="buttons" :permissions="permissions" :parameters="[{key: 'linkedid', value: linkedid}]">
        <template #title>
            {{ more.title }}
        </template>

        <template #content>
             <div class="prelative min-h-100">
                <preloader :display="loading"/>
                <div  v-if="!loading" id="two-columns-v1" v-html="htmlData"></div>
            </div>
           
        </template>
    </tab-layout>
</template>

<script>
    import OverviewTabMixin from './OverviewTabMixin'
    import { buildUrl } from '../../../helpers';
    import Preloader from "vcomponents/utilities/Preloader.vue";
    import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

    export default {
        mixins: [OverviewTabMixin],
        props: {
            more: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                loading: true,
                htmlData: '',
                response : false
            }
        },
        created(){
            this.fetch().then(() => {
                this.initListingv1()
            })
        },
        computed: {
            buttons(){
                return this.more.buttons.map(button => {
                    // button.linkedid = this.$store.getters.linkedid
                    // button.linkedtype = this.$store.getters.linkedtype
                    return button
                })
            },
            permissions() {
                return this.$store.getters.permissions
            }
        },
        methods: {
            fetch() {
                return new Promise((resolve, reject) => {

                    this.loading = true
                    var params = {
                        action		: this.more.action, 
                        thirdid     : this.linkedid,
                    };
                    axios.post(this.more.url, params)
                        .then((response) => {
                            if (response.data.contentTab !== undefined) {
                                this.htmlData = response.data.contentTab
                                this.response = response.data
                                this.loading = false
                                resolve()
                            } else{
                                this.htmlData = response.data.error;
                            }

                        })
                        .catch((error) => {
                            
                        })
                })
                
                
            },
            initListingv1(){
                Ticket.getListing(true);
            }
        },

        components: {
            Preloader,
            TabLayout,
        }
    }
</script>

<style lang="scss">
    #listing-v1>header{
        display: none;
    }
    // #listing-v1 .listingTools{
    //     display: none;
    // }
    #listing-v1 #massmailingContactProfile h3{
        display: none;
    }

</style>